import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import _ from "lodash"
import "./index.css";

import googleChatIcon from "../../images/google_chat_icon.png"

import TextInputField from '../../helpers/TextInputField';
import DropDownField from '../../helpers/DropDownField';
import Button from '../../helpers/Button';
import { Dialog } from "primereact/dialog";
import { InputSwitchField } from '../../helpers';
import { Tooltip } from "primereact/tooltip";

import { validateInputs, combineISDCodeWithPhoneNumber, extractISDAndPhoneNumber, isMobile, getColorFromName, getDuplicatesInArray, checkPermissions } from '../../utils'
import { EditUserProfileValidationSchema } from '../../validation/userProfileValidation';

import AddUserRoles from '../../common/AddUserRole'
import UserProfile from '../../common/UserProfile';

import OtpVerification from './Components/OtpVerification';

import { raiseToast } from '../../services/redux/reducers/toast/toast';
import { fetchCountries, fetchCompanyRoleHierarchyData } from '../../services/redux/reducers/commonThunk';

import { getUserById, updateUserById, getUsers, searchUserRoles, companyUserRoleValidation } from '../../services/api/user';
import { getCompanies } from '../../services/api/company';
import { getBranchesList } from '../../services/api/companyBranch';
import { getStatus } from '../../services/api/status'
import { getCompanyRolesData } from '../../services/api/companyRole';
import { googleAuthenticationForSendMail } from '../../services/api/auth';
import { getPMCompanyConfig } from '../../setup/pmCompanyConfig';
import { getGoogleUserChatUri } from '../../services/api/googleChat'

import UserProfileSkeleton from '../../skeletons/userProfile';
import UserProfileMobileSkeleton from '../../skeletons/userProfileMobile';


const EditUser = () => {
    const {userId} = useParams()

    const [userData, setUserData] = useState({})
    const [editedUserData, setEditedUserData] = useState({})
    const [companies, setCompanies] = useState([])
    const [branches, setBranches] = useState([])
    const [companyRoles, setCompanyRoles] = useState([])
    const [userRoles, setUserRoles] = useState([])
    const [editedUserRoles, setEditedUserRoles] = useState([])
    const [status, setStatus] = useState([])
    const [formErrors, setFormErrors] = useState({});
    const [addNewRolesVisible, setAddNewRolesVisible ] = useState(false)
    const [editUserFlag, setEditUserFlag ] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [managerUsersData, setManagerUsersData] = useState([])
    const [isOtpVerificationDialogVisible, setIsOtpVerificationDialogVisible] = useState(false)
    const [updatedPhoneNumber, setUpdatedPhoneNumber] = useState(null)
    const [updateUserObj, setUpdateUserObj] = useState({})

    const pmUserId = useSelector((state) => state.userDetails.userId)
    const countriesData = useSelector(state => state.common.countries)
    const userDetails = useSelector((state) => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.activeUserRoleDetails.companyId)
    const companyRoleHierarchy = useSelector(state => state.common.companyRoleHierarchy)
    const userNameDetails = useSelector((state) => state.userDetails.userNameDetails)
    
    const dispatch = useDispatch()
    
    useEffect(()=>{
        dispatch(fetchCountries())
        dispatch(fetchCompanyRoleHierarchyData())
    },[])

    useEffect(()=>{
        loadInitialData()
    },[countriesData])

    const loadInitialData = async () => {
        let company_ids = []
        let branch_ids = []
        let company_roles_ids = []
        let managerIds = []

        const userDataResponse = await getUserById(userId);
        console.log("userData-response", userDataResponse)
        if(userDataResponse){
            
            let userProfileObj = userDataResponse.data[0]
            let editUserProfileObj = { ...userDataResponse.data[0] }

            if (userDataResponse.data[0]?.phoneNumber) {
                let { ISDCode, phoneNumber } = extractISDAndPhoneNumber(userDataResponse.data[0].phoneNumber)
                let relatedISDCode = countriesData.find(eachCountry => eachCountry.ISDCode === ISDCode)

                if(relatedISDCode){
                    editUserProfileObj.ISDCode = ISDCode
                }

                editUserProfileObj.phoneNumber = phoneNumber
            }

            setUserData(userProfileObj)
            setEditedUserData(JSON.parse(JSON.stringify(editUserProfileObj)))

            setUserRoles(userDataResponse.data[0].userRoles)
            let relatedUserRoles = userDataResponse?.data[0]?.userRoles.filter(eachRole => eachRole.branchId !== null)
            setEditedUserRoles(JSON.parse(JSON.stringify(relatedUserRoles)))

            if(userDataResponse?.data[0]?.userRoles){
                userDataResponse.data[0].userRoles.map(roles=>{
                    if(!company_ids.includes(roles.companyId)){
                        company_ids.push(roles.companyId)
                    }

                    if(!branch_ids.includes(roles.branchId)){
                        branch_ids.push(roles.branchId)
                    }

                    if(!company_roles_ids.includes(roles.companyRoleId)){
                        company_roles_ids.push(roles.companyRoleId)
                    }

                    if(roles.managerId && !company_roles_ids.includes(roles.managerId)){
                        managerIds.push(roles.managerId)
                    }
                })
            }
        }
        
        getCompanyData(company_ids)
        getCompanyBranchData(branch_ids)
        getCompanyRoles(company_roles_ids)
        getUsersData(managerIds)

        let status_lazyparams = {
            include: [],
            statusIds: [1,2],
            recordsPerPage: 100
        }

        getStatusData(status_lazyparams)
    }

    const getCompanyData = async (company_ids) => {
        const bodyData = { companyIds: company_ids, recordsPerPage: 50, sortBy: 'companyName' }
        setIsLoading(true)
        const companiesResponse = await getCompanies(bodyData)
        setIsLoading(false)
        console.log("companies-response", companiesResponse)

        if (companiesResponse.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: companiesResponse.data.error, life: 3000 }))
        } else {
            setCompanies(companiesResponse.data.data)
        }
    }

    const getCompanyBranchData = async (branch_ids) => {
        const data = { 
            paginator: false, 
            branchIds: branch_ids, 
            sortBy: 'branchName' 
        }

        setIsLoading(true)
        const companyBranchesData = await getBranchesList(data)
        setIsLoading(false)

        if (companyBranchesData.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: companyBranchesData.data.error, life: 3000 }))
        } else {
            setBranches([{branchId: 0, branchName: "All"},...companyBranchesData.data.data])
        }
    }

    const getCompanyRoles = async (company_roles_ids) => {
        const data = { 
            companyRoleIds: company_roles_ids, 
            sortBy: 'companyRoleName' 
        }

        setIsLoading(true)
        const companyRoleData = await getCompanyRolesData(data)
        setIsLoading(false)

        if (companyRoleData.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: companyRoleData.data.error, life: 3000 }))
        } else {
            setCompanyRoles(companyRoleData.data.data)
        }
    }
    
    const getStatusData = async(status_lazyparams) => {
        const response = await getStatus(status_lazyparams)

        if (response.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        } else {
            setStatus(response.data.data)
        }
    }

    const getUsersData = async (managerIds) => {
        const data = { 
            paginator: false, 
            userIds: managerIds, 
            sortBy: 'firstName', 
            sortOrder: "ASC", 
            statusId: 1 
        }
        const usersData = await getUsers(data)

        if(usersData.status === 200){
            let updatedManagerUsers = usersData?.data?.data.map((eachUser) => {
                if(eachUser?.firstName && eachUser?.lastName){
                    return {
                        ...eachUser,
                        firstName: `${eachUser.firstName} ${eachUser.lastName}`
                    }
                }else{
                    return {
                        ...eachUser
                    }
                }
            })
            setManagerUsersData(updatedManagerUsers)
        }
    }

    const handleUpdateUserRolesStatus = async (userRole,event) =>{

        let relatedCompanyRole = companyRoles.find(eachRole => eachRole.companyRoleId === userRole.companyRoleId && [3, 13, 14].includes(eachRole.companyRoleId))
        let companyRoleHierarchyCompanyIds = _.uniqBy(companyRoleHierarchy, 'companyId').map(obj => obj.companyId)

        if (companyRoleHierarchyCompanyIds.includes(relatedCompanyRole?.companyId)) {
            if (relatedCompanyRole && relatedCompanyRole.companyRoleId === 14 && !event.value) {
                let userRoleparams = {
                    statusId: 1,
                    companyIds: [relatedCompanyRole.companyId],
                    companyRoleIds: [relatedCompanyRole.companyRoleId],
                    branchIds: [userRole.branchId]
                }

                setIsLoading(true)
                const companyUsersRolesDataResponse = await searchUserRoles(userRoleparams)
                setIsLoading(false)

                if (companyUsersRolesDataResponse.failure) {
                    return dispatch(raiseToast({ severity: 'error', detail: companyUsersRolesDataResponse.data.error, life: 3000 }))
                }
                else {
                    let userRoleSRKamData = companyUsersRolesDataResponse.data?.data
                    if (userRoleSRKamData?.length === 0 || (userRoleSRKamData?.length === 1 && userRoleSRKamData[0].userRoleId === userRole.userRoleId)) {
                        return dispatch(raiseToast({ severity: 'warn', detail: "Company branch should have atleast 1 SR Kam" }))
                    }
                }
            }

            if (relatedCompanyRole && relatedCompanyRole.companyRoleId === 3) {
                return dispatch(raiseToast({ severity: 'warn', detail: "Company branch can only 1 branch head" }))
            }

            if (relatedCompanyRole && relatedCompanyRole.companyRoleId === 13) {
                return dispatch(raiseToast({ severity: 'warn', detail: "Company branch can only 1 regional head" }))
            }
        }

        editedUserRoles.map(role=>{
            if(role.userRoleId === userRole.userRoleId){
                role.statusId = event.value === true ? 1 : 2
            }
        })
        setEditedUserRoles([...editedUserRoles])
    }

    const handleChangeUserProfile = (event) => {
        editedUserData[event.target.name] = event.target.value
        setEditedUserData({...editedUserData})
    }

    const handleUpdateUserStatus = async (statusId) => {
        if(statusId === 1){
            if(window.confirm("Do u want to deactivate this user")){
                setEditedUserData({...editedUserData, statusId: 2})
            }
        }else{
            if(window.confirm("Do u want to activate this user")){
                setEditedUserData({...editedUserData, statusId: 1})
            }
        }
    }

    const handleSubmitUserProfile = async () => {
        const validation_res = await validateInputs(EditUserProfileValidationSchema, editedUserData, pmCompanyConfig)
        console.log("validation-response",validation_res)
        if (validation_res) {
            if (validation_res.error) {
                setFormErrors(validation_res.error)
            }
            else {
                setFormErrors({})
                
                let updatedEditedUserProfile = { ...validation_res.result }
                updatedEditedUserProfile.phoneNumber = combineISDCodeWithPhoneNumber(updatedEditedUserProfile.ISDCode, updatedEditedUserProfile.phoneNumber)
                delete updatedEditedUserProfile.ISDCode

                let updatedUserProfileDetails = {}
                let isPhoneUpdated = false
                if(JSON.stringify({...updatedEditedUserProfile}) !== JSON.stringify(userData)){
                    isPhoneUpdated = updatedEditedUserProfile.phoneNumber !== userData.phoneNumber
                    updatedUserProfileDetails = {...updatedEditedUserProfile}
                }

                let updatedUserRoles = []
                editedUserRoles.map(editedRole => {
                    if (editedRole.isNew) {
                        updatedUserRoles.push(editedRole)
                    }
                    else {
                        let prevRoleValues = JSON.stringify(userRoles.find(prevRole => prevRole.userRoleId === editedRole.userRoleId))
                        let newRoleValues = JSON.stringify(editedRole)
                        
                        if (newRoleValues !== prevRoleValues) {
                            updatedUserRoles.push(JSON.parse(newRoleValues))
                        }
                    }
                })
                
                let updateUserObj = {
                    updatedUserProfileDetails, 
                    updatedUserRoles
                }

                const stringUserRoles = editedUserRoles.filter(eachUserRole => eachUserRole.branchId !== 0 && eachUserRole.statusId === 1).map(eachUserRole => { 
                    return {statusId: eachUserRole.statusId.toString(), branchId: eachUserRole.branchId.toString(), companyId: eachUserRole.companyId.toString()} 
                })
                const duplicatesInArray = getDuplicatesInArray(stringUserRoles, ["statusId", "branchId", "companyId"])

                if(duplicatesInArray.length) {
                    let firstUserRoleDuplicate = duplicatesInArray[0]
                    let firstRoleCompany = companies.find(eachCompany => eachCompany.companyId === parseInt(firstUserRoleDuplicate.companyId))
                    let firstRoleBranch = branches.find(eachBranch => eachBranch.branchId === parseInt(firstUserRoleDuplicate.branchId))

                    return dispatch(raiseToast({ severity: 'error', detail: `Multiple active roles found for branch ${firstRoleCompany.companyName} - ${firstRoleBranch.branchName}` }))
                }
                if(isPhoneUpdated && updatedEditedUserProfile.userId === userDetails.userId){
                    setUpdatedPhoneNumber(updatedEditedUserProfile.phoneNumber)
                    setUpdateUserObj(updateUserObj)
                    setIsOtpVerificationDialogVisible(true)
                }
                else{
                    setIsOtpVerificationDialogVisible(false)
                    updateUserProfileData(updateUserObj, validation_res.result.userId)
                }
            }
        }
    }

    const updateUserProfileData = async (updateUserObj, userId) => {
        if (window.confirm("Do you want to save user profile..?")) {
            setIsLoading(true)
            let updateUserProfileResponse = await updateUserById(updateUserObj, userId)
            setIsLoading(false)
            console.log("updateUserProfile--response", updateUserProfileResponse)

            if (updateUserProfileResponse.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: updateUserProfileResponse.data.error, life: 3000 }))
            } else {
                setAddNewRolesVisible(false)
                setEditUserFlag(false)

                if (updateUserProfileResponse?.data?.updatedUserData?.length) {
                    let updatedUser = updateUserProfileResponse.data.updatedUserData[0]
                    let userProfileObj = {...updatedUser}
                    let editUserProfileObj = { ...updatedUser }

                    if (updatedUser.phoneNumber) {
                        let { ISDCode, phoneNumber } = extractISDAndPhoneNumber(updatedUser.phoneNumber)
                        let relatedISDCode = countriesData.find(eachCountry => eachCountry.ISDCode === ISDCode)

                        if (relatedISDCode) {
                            editUserProfileObj.ISDCode = ISDCode
                        }

                        editUserProfileObj.phoneNumber = phoneNumber
                    }

                    setUserData(userProfileObj)
                    setEditedUserData(JSON.parse(JSON.stringify(editUserProfileObj)))
                }

                if(updateUserProfileResponse?.data?.userRoles?.length>0){
                    
                    let updatedBranchUserRoledIds = []
                    let updatedBranchUsersRoles = userRoles?.map(eachUserRole => {
                        updatedBranchUserRoledIds.push(eachUserRole.userRoleId)
                        let relatedUpdatedBranchUser = updateUserProfileResponse?.data?.userRoles?.find(eachRole => eachRole.userRoleId === eachUserRole.userRoleId)
                        if(relatedUpdatedBranchUser){
                            return {...relatedUpdatedBranchUser}
                        }
                        return {...eachUserRole}
                    })
                    
                    let updatedNewBranchUserRoles = updateUserProfileResponse?.data?.userRoles?.filter(eachUserRole => !updatedBranchUserRoledIds.includes(eachUserRole.userRoleId))

                    let updatedEditedUserRoles = updatedBranchUsersRoles.filter(eachRole => eachRole.branchId !== null)
                    
                    setUserRoles([...updatedBranchUsersRoles, ...updatedNewBranchUserRoles])
                    setEditedUserRoles([...updatedEditedUserRoles, ...updatedNewBranchUserRoles])
                    
                }

                return dispatch(raiseToast({ severity: 'success', detail: "User profile updated successfully", life: 3000 }))
            }
        }
    }

    const handleAddUserRole = async(newUserRoleObj, selectedCompany, selectedBranch, selectedCompanyRole, relatedManager) => {
        let relatedUserRole = editedUserRoles.find(role => role.userId === newUserRoleObj.userId && role.companyId === newUserRoleObj.companyId && role.branchId === newUserRoleObj.branchId && role.companyRoleId === newUserRoleObj.companyRoleId && role.pmCompanyId === selectedCompany.pmCompanyId )
        if(relatedUserRole){
            return dispatch(raiseToast({ severity: 'warn', detail: "Role already exists" }))
        }

        let existingBranchUserRole = editedUserRoles.find(role => role.userId === newUserRoleObj.userId && role.companyId === newUserRoleObj.companyId && role.branchId === newUserRoleObj.branchId && role.statusId === newUserRoleObj.statusId && role.branchId !== 0 && role.pmCompanyId === selectedCompany.pmCompanyId)
        if(existingBranchUserRole){
            return dispatch(raiseToast({ severity: 'warn', detail: "Role already exists in this branch! please deactive the preious role to continue" }))
        }

        let data = {
            companyRoleName: selectedCompanyRole.companyRoleName,
            companyRoleId: selectedCompanyRole.companyRoleId,
            companyId: selectedCompany.companyId,
            branchId: selectedBranch.branchId,
            userId: newUserRoleObj.userId,
            pmCompanyId: selectedCompany.pmCompanyId,
            isUserLevel: true
        }
        setIsLoading(true)
        const companyUserRoleValidationResponse = await companyUserRoleValidation(data)
        setIsLoading(false)
        if (companyUserRoleValidationResponse.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: companyUserRoleValidationResponse.data.error, life: 3000 }))
        } else {
            let responseData = companyUserRoleValidationResponse.data
            if(responseData){
                return dispatch(raiseToast({ severity: 'error', detail: "Given role already exists for this user. Plz refresh the page.", life: 3000 }))
            }
        }
        
        let relatedBranchUser = userRoles?.find(eachRole => eachRole.userId === parseInt(userId) && eachRole.branchId === null && eachRole.companyId === newUserRoleObj?.companyId)
        
        if(relatedBranchUser){
            relatedBranchUser.companyRoleId = newUserRoleObj?.companyRoleId
            relatedBranchUser.branchId = newUserRoleObj?.branchId
            relatedBranchUser.managerId = newUserRoleObj?.managerId
            relatedBranchUser.statusId = 1

            delete newUserRoleObj.isNew

            setUserRoles([...userRoles])
            setEditedUserRoles([...editedUserRoles, {...newUserRoleObj, userRoleId: relatedBranchUser.userRoleId}])
            if(editedUserData.statusId === 2){
                setEditedUserData({...editedUserData, statusId: 1})
            }
        }else{
            setEditedUserRoles([...editedUserRoles, {...newUserRoleObj}])
        }
        
        if(selectedCompany){
            setCompanies([...companies, selectedCompany])
        }

        if(selectedBranch){
            setBranches([...branches, selectedBranch])
        }

        if(selectedCompanyRole){
            setCompanyRoles([...companyRoles, selectedCompanyRole])
        }

        if(relatedManager){
            let relatedManagerUser = managerUsersData.find(eachUser => eachUser.userId === relatedManager.userId)
            if(!relatedManagerUser){
                setManagerUsersData([...managerUsersData, relatedManager])
            }
        }
        
        setAddNewRolesVisible(false)
    }

    const handleDiscardUserProfile = () =>{
        if(window.confirm("Are you sure you want to discard the changes")){
            setEditUserFlag(false)

            let editUserProfileObj = { ...userData }
            if (userData.phoneNumber) {
                let { ISDCode, phoneNumber } = extractISDAndPhoneNumber(userData.phoneNumber)
                let relatedISDCode = countriesData.find(eachCountry => eachCountry.ISDCode === ISDCode)

                if(relatedISDCode){
                    editUserProfileObj.ISDCode = ISDCode
                }

                editUserProfileObj.phoneNumber = phoneNumber
            }

            setEditedUserData(editUserProfileObj)
            setEditedUserRoles([...userRoles])
        }
    }

    const handleUserGoogleVerification = async () => {
        const response = await googleAuthenticationForSendMail()
        if(response.failure) return dispatch(raiseToast({severity:'error', summary: 'Google Verification', detail: response.data.error, life: 3000}))

        const popupWidth = 500
        const popupHeight = 400
        const left = (window.screen.width - popupWidth) / 2
        const top = (window.screen.height - popupHeight) / 2

        window.open(response?.data, 'Popup Window', `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`)
    }

    const handleGetGoogleUserChatUri = async (approvalEmail) => {
        if (!approvalEmail) {
            return dispatch(raiseToast({ severity: 'error', detail: "Approval user not found. Please contact tech team", life: 3000 }))
        }
        let data = {
            userId: pmUserId,
            emailId: approvalEmail
        }
        
        setIsLoading(true)
        const getGoogleUserChatUriRes = await getGoogleUserChatUri(data)
        setIsLoading(false)

        if (getGoogleUserChatUriRes.failure) {
            if (window.confirm("Chat with the user doesn't exist.\nPlease open chat manually, and send the message.")) {
                window.open("https://mail.google.com/mail/u/0/?tab=rm&ogbl#chat/home", '_blank')
            }
        } else {
            window.open(getGoogleUserChatUriRes.data, '_blank')
        }
    }

    const renderUserInfoSkeleton = () => <UserProfileSkeleton />
    const renderUserInfoMobileSkeleton = () => <UserProfileMobileSkeleton />

    if(isLoading){
        return(
            isMobile() ? renderUserInfoMobileSkeleton() : renderUserInfoSkeleton()
        )
    }

    let editMobileAndEmailPermissions = []
    const isProcmartUser = userDetails.rolesList.find(eachRole => eachRole.companyId === userDetails.PMCompanyDetails.companyId)
    const isUserBuyerOrBoth = companies.some(eachCompany => [1, 3].includes(eachCompany.buyerSeller))
    const isUserSeller = companies.some(eachCompany => eachCompany.buyerSeller === 2)

    const isPMUser = userRoles.find(eachRole => eachRole.companyId === userDetails.PMCompanyDetails.companyId)
    if(userDetails.userId === userData.userId){
        editMobileAndEmailPermissions = []
    } else if(isPMUser){
        editMobileAndEmailPermissions = [258]
    } else if(isUserBuyerOrBoth){
        editMobileAndEmailPermissions = [235]
    } else if(isUserSeller){
        editMobileAndEmailPermissions = [236]
    }


    return (
        <> 
            <div className="edit-profile-page">
                <div className="p-card">
                    
                    <div className="mb-3 flex flex-column md:flex-row md:justify-content-between">
                        <h4 className="md:mb-2 mx-2 my-1">User Profile</h4>
                        {
                            editUserFlag ?
                                <div className='flex justify-content-end'>
                                    <Button className="small-btn discard-btn" style={{marginRight:"10px"}} label="DISCARD" onClick={handleDiscardUserProfile} />
                                    <Button className="small-btn" label="SAVE" onClick={handleSubmitUserProfile} />
                                </div>
                                :
                                <div className='flex justify-content-end'>
                                    <Button className="small-btn" style={{ marginRight: '10px' }} label="EDIT" onClick={ () => setEditUserFlag(true) } permissions={[113]}/> 
                                </div>
                        }
                    </div>

                    <div className="flex md:flex-row flex-column md:p-2 pt-0 px-2 pb-2">
                        <div className='flex user-profile-img-container'  style={{ position: "relative" }}>
                            <UserProfile userNameDetails={userData} className="user-profile-img"/>
                            {/* <div className='profile-pencil-icon-container'> 
                                <div className='flex justify-content-center align-items-center' style={{ background: "#eeeeee", width: "2.5rem", height: "2.5rem", borderRadius: "50%"}}>
                                    <i className='pi pi-pencil' style={{ fontSize: '1rem' , color: "black"}}></i>
                                </div> 
                            </div> */}
                        </div>
                        <div className="flex md:flex-row flex-column align-items-end mb-2 md:mx-2">
                            <div className="flex flex-column col-12 md:col-2">
                                <TextInputField name="firstName" labelText="First Name" value={editedUserData.firstName} errorMessage={formErrors.firstName} onChange={ handleChangeUserProfile } required = {true} disabled={!editUserFlag} maxLength={100} />
                            </div>
                            <div className="flex flex-column col-12 md:col-2">
                                <TextInputField name="lastName" labelText="Last Name" value={editedUserData.lastName} errorMessage={formErrors.lastName} onChange={ handleChangeUserProfile } disabled={!editUserFlag} maxLength={100} />
                            </div>
                            <div className="flex flex-column col-12 md:col-3">
                                <label htmlFor="emailId" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                    Email ID
                                    <a style={{ cursor: "pointer" }} onClick={() => handleGetGoogleUserChatUri(editedUserData.emailId)}>
                                        <img
                                            className="ml-1 mb-0 mt-0"
                                            src={googleChatIcon}
                                            style={{ height: 13 }}
                                            alt="Google Chat"
                                        />
                                    </a>
                                </label>
                                <TextInputField name="emailId" labelText="" value={editedUserData.emailId } errorMessage={formErrors.emailId} onChange={ handleChangeUserProfile } disabled={!editUserFlag} permissions={editMobileAndEmailPermissions} maxLength={100} />
                            </div>
                            <div className="flex flex-column col-12 md:col-2">
                                <DropDownField name="ISDCode" labelText="ISD Code" options={countriesData} optionLabel="ISDCode" optionValue="ISDCode" value={editedUserData.ISDCode } onChange={ handleChangeUserProfile } disabled={!editUserFlag} permissions={editMobileAndEmailPermissions} errorMessage={formErrors.ISDCode} />
                            </div>
                            <div className="flex flex-column col-12 md:col-2">
                                <label htmlFor="phoneNumber" className="flex" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                    Phone Number
                                    <div style={{ cursor: 'pointer' }} onClick={() => window.open(`https://wa.me/${editedUserData.phoneNumber}`)}>{editedUserData.phoneNumber && <i className="pi pi-whatsapp pl-1 doc-copy-icon" style={{ color: "#00baaa" }}></i>}</div>
                                </label>
                                <TextInputField name="phoneNumber" labelText="" keyfilter={"pnum"} value={editedUserData.phoneNumber} errorMessage={formErrors.phoneNumber} onChange={ handleChangeUserProfile } disabled={!editUserFlag} permissions={editMobileAndEmailPermissions} maxLength={10} />
                            </div>   
                            <div className="flex flex-column col-12 md:col-2 mb-2">
                                <label className="text-xs mr-2 mb-2">Status</label>
                                <InputSwitchField name="status"  checked={editedUserData.statusId === 1 ? true : false} onChange={() => handleUpdateUserStatus(editedUserData.statusId)} disabled={!editUserFlag} permissions={[31, 32]}/>
                            </div>   
                        </div>
                    </div>
                    {/* <div className='flex flex-column md:flex-row md:align-items-center'>
                        <h5 className="mt-2 ml-2">Google Verification</h5>
                        {
                            parseFloat(userId) === pmUserId && <div className='md:ml-3 mt-2 flex justify-content-end'>
                                <Button className="small-btn" label="Verify" onClick={handleUserGoogleVerification} />
                            </div>
                        }
                        {userData?.googleRefreshToken && <i className='pi pi-check-circle ml-2' style={{ color: "#00baac", fontSize: "1.1rem" }}> Verified</i>}
                    </div> */}
                    <h5 className="mt-2 ml-2">Roles</h5>
                        <div className="px-2">
                            <div className="post-req-table user-profile-table">
                                <table className="custom-table">
                                    <thead>
                                        <tr className="custom-table-tr custom-tr">
                                            <th className="custom-th sr-no" style={{fontSize: "14px"}}>Sr No</th>
                                            <th className="custom-th" style={{fontSize: "14px"}}>Company</th>
                                            <th className="custom-th" style={{fontSize: "14px"}}>Branch</th>
                                            <th className="custom-th" style={{fontSize: "14px"}}>Role</th>
                                            <th className="custom-th" style={{fontSize: "14px"}}>Manager</th>
                                            <th className="custom-th" style={{fontSize: "14px"}}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {   
                                            editedUserRoles.length > 0 ? (
                                                editedUserRoles.map((role, index) => (
                                                    <tr className="custom-table-tr custom-tr">
                                                        <td className="custom-td text-center sr-no" style={{fontSize: "14px"}}>{index + 1}</td>
                                                        <td className="custom-td"><DropDownField placeholder="Please select a company" options={companies} optionLabel="companyName" optionValue="companyId" value={role.companyId} disabled /></td>
                                                        <td className="custom-td"><DropDownField placeholder="Please select a branch" options={branches} optionLabel="branchName" optionValue="branchId" value={role.branchId} disabled /></td>
                                                        <td className="custom-td"><DropDownField placeholder="Please select a role" options={companyRoles} optionLabel="companyRoleName" optionValue="companyRoleId" value={role.companyRoleId} disabled /></td>
                                                        <td className="custom-td"><DropDownField placeholder="Please select a user" options={managerUsersData} optionLabel="firstName" optionValue="userId" value={role.managerId} disabled /></td>
                                                        <td className="custom-td text-center"><InputSwitchField onChange={(event) => handleUpdateUserRolesStatus(role, event)} checked={role.statusId === 1 ? true : false} disabled={!editUserFlag} permissions={[113]}/> </td> {/* onChange={(event) => handleUpdateUserRolesStatus(role, event)} */}
                                                </tr>
                                                ))
                                            ) : ""
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    <div className='mt-3 flex justify-content-start'>
                        <Button className="increment-btn-icon small-btn" icon="pi pi-plus-circle" text size="large" onClick={()=> setAddNewRolesVisible(true)} disabled={!editUserFlag} permissions={[113]}/>
                    </div>
                    <Dialog className='add-new-role-dialog' header="Add New Role" visible={addNewRolesVisible} style={{ width: '', minHeight: "35%" }} onHide={() => setAddNewRolesVisible(false)} >
                        <AddUserRoles handleAddUserRole={handleAddUserRole} />
                    </Dialog>
                    <Dialog className='add-new-role-dialog' header="OTP VERIFICATION" visible={isOtpVerificationDialogVisible} style={{ width: '', minHeight: "35%" }} onHide={() => setIsOtpVerificationDialogVisible(false)} >
                        <OtpVerification updatedPhoneNumber={updatedPhoneNumber} setIsOtpVerificationDialogVisible={setIsOtpVerificationDialogVisible} updateUserObj={updateUserObj} updateUserProfileData={updateUserProfileData}/>
                    </Dialog>
                </div>
            </div>
        </>
    )
}

export default EditUser;
